import React, { useContext, useEffect, useState } from "react";
import { Location, useLocation, useNavigate } from "react-router-dom";
import { ChannelSubstate, ChannelState, getChannelStatusString } from "../../models/SKChannel";
import { Link } from "react-router-dom";
import { useNavigationBar } from "../../context/NavigationContext";

interface HistoryNavigatorProps {
  title?: string;
  channelStatus: string;
  docId: string;
}

export default function HistoryNavigator({ title, channelStatus, docId }: HistoryNavigatorProps) {
  //const [editable, setEditable] = useState<boolean>(true);
  const navigate = useNavigate();

  //const location = useLocation();

  return (
    <div className="relative w-full min-w-[200px]">
      <div className="flex items-center pb-[10px]">
        <span className="content_title">{title}</span>
      </div>
      <Link to={`history`}>
        <div
          id="content-item"
          className="cursor-pointer input-content-topic"
          tabIndex={0}
          //onClick={() => navigate("../history", { state: { editable } })}
        >
          <div className="flex items-center justify-between w-full">
            <div id="topic" className="flex input-content-topic-text">
              View Status History
            </div>

            <div id="title" className="flex m-[15px]">
              <div className="input-content-topic-title">{channelStatus}</div>
              {/* <span className="input-plus-topic ml-[5px]">
              <img
                src={imgSrc}
                className="object-contain w-[19px] h-[20px] min-w-5"
                alt="Certification status"
              />
            </span> */}
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}
